import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ServicesHero = () => {
  const { t } = useTranslation();

  const stats = [
    { value: '9+', label: t('services.hero.stats.services') },
    { value: '100%', label: t('services.hero.stats.custom') },
    { value: '24/7', label: t('services.hero.stats.support') },
  ];

  return (
    <section className="relative min-h-[65vh] flex items-center justify-center overflow-hidden bg-[#050008] pt-20">
      {/* Background layers */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0d0020] via-[#050008] to-[#000d1a]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_25%_50%,rgba(0,194,255,0.12)_0%,transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_75%_50%,rgba(255,45,170,0.10)_0%,transparent_60%)]" />
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: 'linear-gradient(rgba(0,194,255,0.8) 1px, transparent 1px), linear-gradient(90deg, rgba(0,194,255,0.8) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 text-center py-20">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/5 border border-[#00c2ff]/30 rounded-full px-4 py-2 mb-7">
          <i className="ri-service-line text-[#00c2ff] text-sm" />
          <span className="text-[#00c2ff] text-xs font-bold uppercase tracking-widest">{t('services.hero.badge')}</span>
        </div>

        {/* Headline */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
          {t('services.hero.titlePrefix')}<br />
          <span className="bg-gradient-to-r from-[#00c2ff] via-[#8c52ff] to-[#FF2DAA] bg-clip-text text-transparent">
            {t('services.hero.titleHighlight')}
          </span>
        </h1>

        <p className="text-white/55 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-10">
          {t('services.hero.subtitle')}
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-14">
          <Link
            to="/contact"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#8c52ff] to-[#00c2ff] text-white font-bold px-8 py-4 rounded-full hover:opacity-90 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-calendar-line" />
            {t('services.hero.cta.book')}
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2 bg-white/5 border border-white/20 text-white font-semibold px-8 py-4 rounded-full hover:bg-white/10 transition-all duration-300 cursor-pointer"
          >
            {t('services.hero.cta.team')}
          </Link>
        </div>

        {/* Stats */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-14">
          {stats.map((s, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl md:text-3xl font-black bg-gradient-to-r from-[#00c2ff] to-[#8c52ff] bg-clip-text text-transparent">
                {s.value}
              </div>
              <div className="text-white/40 text-xs uppercase tracking-wider mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
